import * as types from '../types/faqTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
};

export default function faqReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_FAQS_REQUEST:
      return { ...state, loading: true, error: null };
    case types.GET_FAQS_SUCCESS:
      return { ...state, loading: false, error: null, list: Array.isArray(action.payload) ? action.payload : [] };
    case types.GET_FAQS_FAILURE:
      return { ...state, loading: false, error: action.payload || 'Failed to load FAQs' };
    default:
      return state;
  }
}
